import {HttpStatusCode} from '@angular/common/http';
import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ReferenceBookResponse, ReferenceBookType, ResolutionApiService, ResolutionStatus} from '@npck/af-frontend-api';
import {rxSpinner} from '@npck/libs/commons';
import {forkJoin} from 'rxjs';
import {mapResolutionStatusToStyle} from '../../../../components/status/status.component';
import {DictionaryHolderService, findValueInDictionary} from '../../../../domain/dictionary-holder.service';
import {Resolution, ResolutionService} from '../../../../domain/resolution.service';

@Component({
    templateUrl: 'resolution-info-dialog.component.html',
    styleUrls: ['resolution-info-dialog.component.scss'],
    standalone: false,
})
export class ResolutionInfoDialogComponent {
    resolution: Resolution | null = null;
    incidentStatusDict: ReferenceBookResponse[] = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: ResolutionInfoDialogData,
        public dialogRef: MatDialogRef<ResolutionInfoDialogComponent>,
        private resolutionApiService: ResolutionApiService,
        private resolutionService: ResolutionService,
        private dictionaryHolderService: DictionaryHolderService,
    ) {
        forkJoin({
            resolution: this.resolutionApiService.getResolution(dialogData.incidentId),
            incidentStatusDict: this.dictionaryHolderService.getReference(ReferenceBookType.INCIDENT_STATUS),
        })
            .pipe(rxSpinner('resolutions'))
            .subscribe({
                next: ({resolution, incidentStatusDict}) => {
                    this.incidentStatusDict = incidentStatusDict;
                    this.resolution = resolution ? <Resolution>{
                        id: resolution.id,
                        fields: this.resolutionService.fieldBuilder(resolution),
                        status: resolution.status,
                        createdDate: resolution.createdDate,
                        statusStyle: mapResolutionStatusToStyle(resolution.status),
                        solutionInfo: dialogData.identificationNumber
                            ? resolution.solutionInfo?.filter(s => s.identificationNumber === dialogData.identificationNumber)
                            : resolution.solutionInfo,
                    } : null;
                },
                error: err => {
                    if (err.status !== HttpStatusCode.NotFound) {
                        throw err;
                    }
                },
            });
    }

    statusLabel(status: ResolutionStatus): string {
        return findValueInDictionary(this.incidentStatusDict, status, 'name_ru');
    }
}

export interface ResolutionInfoDialogData {
    incidentId: string;
    identificationNumber?: string;
}
